<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import ApiClass from "../../../api/api";

// import { OveviewChart } from "./data";
/**
 * Wallets component
 */
export default {
  page: {
    title: "Wallets",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      tron: '<svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 64 64"><defs><style>.cls-1{fill:#ff060a;}</style></defs><title>tron</title><g id="tron"><path class="cls-1" d="M61.55,19.28c-3-2.77-7.15-7-10.53-10l-.2-.14a3.82,3.82,0,0,0-1.11-.62l0,0C41.56,7,3.63-.09,2.89,0a1.4,1.4,0,0,0-.58.22L2.12.37a2.23,2.23,0,0,0-.52.84l-.05.13v.71l0,.11C5.82,14.05,22.68,53,26,62.14c.2.62.58,1.8,1.29,1.86h.16c.38,0,2-2.14,2-2.14S58.41,26.74,61.34,23a9.46,9.46,0,0,0,1-1.48A2.41,2.41,0,0,0,61.55,19.28ZM36.88,23.37,49.24,13.12l7.25,6.68Zm-4.8-.67L10.8,5.26l34.43,6.35ZM34,27.27l21.78-3.51-24.9,30ZM7.91,7,30.3,26,27.06,53.78Z"/></g></svg>',
      // OveviewChart: OveviewChart,
      title: "Wallets",
      items: [
        {
          text: "Crypto",
          href: "/admin",
        },
        {
          text: "Wallets",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        {
          key: "id",
          label: "ID No",
          sortable: true,
        },

        {
          key: "order_type",
          sortable: true,
        },
        {
          key: "currency",
          sortable: true,
        },
        {
          key: "quantity",
          sortable: true,
        },
        {
          label: "Status",
          key: "current_status",
          sortable: true,
        },

        {
          key: "created_at",
          sortable: true,
        },
      ],
      userData: "",
      walletInfo: [],
      buyData: [],
      sellData: [],
      activitiesData: [],
      // copy_text: ["Copy", "Copy", "Copy"],
      copy_text0: "Copy",
      copy_text1: "Copy",
      copy_text2: "Copy",

      // copy_text: [],
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.activitiesData.length;
    },
    rowsBuy() {
      return this.buyData.length;
    },
    rowsSell() {
      return this.sellData.length;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;

    this.adminGet();

    console.log(this.buyData);
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    copyAddress(id = null, index = null) {
      // index = parseInt(index);
      console.log("hi");
      var copyText = document.getElementById(id);
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      var res = document.execCommand("copy");
      var $this = this;
      switch (index) {
        case 0:
          this.copy_text0 = res ? "Copied" : "Copy";
          setTimeout(() => {
            $this.copy_text0 = "Copy";
          }, 2000);
          break;
        case 1:
          this.copy_text1 = res ? "Copied" : "Copy";
          setTimeout(() => {
            $this.copy_text1 = "Copy";
          }, 2000);
          break;
        case 2:
          this.copy_text2 = res ? "Copied" : "Copy";
          setTimeout(() => {
            $this.copy_text2 = "Copy";
          }, 2000);
          break;

        default:
          break;
      }
    },

    async adminGet() {
      var res = await ApiClass.getRequest("admin/users/admin_info_get", true);
      console.log("admin=======", res);
      this.userData = res.data.data.user;
      this.walletInfo = res.data.data.wallet;
      this.activitiesData = res.data.data.orders;
      this.buyData = this.activitiesData.filter(
        (item) => item.order_type == "buy"
      );
      this.sellData = this.activitiesData.filter(
        (item) => item.order_type == "sell"
      );
      //http://192.168.10.48/Bitqix/exchange/public/api/admin/users/admin_info_get
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
   <h2 class="text-white">Coming Soon</h2>
    <!-- end row -->
   
  </Layout>
</template>





<style scoped>
.cus-width {
  max-width: 280px;
}
@media all and (max-width: 1900px) {
  .cus-width {
    max-width: 220px;
  }
}
@media all and (max-width: 1600px) {
  .cus-width {
    max-width: 180px;
  }
}
@media all and (max-width: 1400px) {
  .cus-width {
    max-width: 160px;
  }
}
@media all and (max-width: 1200px) {
  .cus-width {
    max-width: 110px;
  }
}
@media all and (max-width: 1100px) {
  .cus-width {
    max-width: 170px;
  }
}

@media all and (max-width: 600px) {
  .cus-width {
    max-width: 100px;
  }
}
@media all and (max-width: 500px) {
  .cus-width {
    max-width: 200px;
  }
}
</style>
